<template>
  <div>
    <pipeline-view-settings></pipeline-view-settings>

    <!--Contacting State-->
    <pipeline-status-section
      :statuses="contactingStatuses"
      :state="ENUMS.StatusStateEnum.Contacting.value"
      description="This is where the leads you are still trying to make initial contact with will reside."
    ></pipeline-status-section>

    <!--Active State-->
    <pipeline-status-section
      :statuses="activeStatuses"
      :state="ENUMS.StatusStateEnum.Active.value"
      description="This is where the leads you are currently working on will reside."
    ></pipeline-status-section>

    <!--Follow Up State-->
    <pipeline-status-section
      :statuses="followUpStatuses"
      :state="ENUMS.StatusStateEnum.FollowUp.value"
      description="This is where the leads you are following up will reside."
    ></pipeline-status-section>

    <!--Completed State-->
    <pipeline-status-section
      :statuses="completedStatuses"
      :state="ENUMS.StatusStateEnum.Completed.value"
      description="This is where the deals that you have completed will reside."
    ></pipeline-status-section>

    <!--Dead State-->
    <pipeline-status-section
      :statuses="deadStatuses"
      :state="ENUMS.StatusStateEnum.Dead.value"
      description="This is where the leads you are no longer pursuing reside."
    ></pipeline-status-section>

    <!--Non Lead State-->
    <pipeline-status-section
      :statuses="nonLeadStatuses"
      :state="ENUMS.StatusStateEnum.NonLead.value"
      description="This is where the leads created by spam calls or website submissions will reside. If you'd like to see these reporting in the stats and reports sections of Forefront, keep them here. If you have test leads you don't want to show up in the stats, delete them."
    ></pipeline-status-section>
  </div>
</template>

<script>
import PipelineViewSettings from "./components/PipelineViewSettings";
import PipelineStatusSection from "./components/PipelineStatusSection";

export default {
  name: "PipelineTab",
  components: {
    PipelineStatusSection,
    PipelineViewSettings,
  },
  computed: {
    contactingStatuses() {
      return this.$store.getters['pipeline/contactingStatuses'];
    },
    activeStatuses() {
      return this.$store.getters['pipeline/activeStatuses'];
    },
    followUpStatuses() {
      return this.$store.getters['pipeline/followUpStatuses'];
    },
    completedStatuses() {
      return this.$store.getters['pipeline/completedStatuses'];
    },
    deadStatuses() {
      return this.$store.getters['pipeline/deadStatuses'];
    },
    nonLeadStatuses() {
      return this.$store.getters['pipeline/nonLeadStatuses'];
    },
  },
}
</script>
